
export default {
	props: [
		'error'
	],
}
